import { EVENTS } from './constants/events'

export function isDone() {
  return new Promise((resolve) => {
    if (
      window.AngularEcommerce &&
      window.AngularEcommerce.DudaWidgets &&
      window.AngularEcommerce.DudaWidgets.onReady
    ) {
      window.AngularEcommerce.DudaWidgets.onReady().then(() => resolve());
    } else {
      window.addEventListener(EVENTS.READY, () => resolve())
    }
  })
}

export function defer() {
  let resolveFn;
  let rejectFn;

  const promise = new Promise((resolve, reject) => {
    resolveFn = resolve;
    rejectFn = reject;
  });

  return {
    resolve: resolveFn,
    reject: rejectFn,
    promise,
  };
}

export function appendLib(scriptSrc, id) {
  return new Promise((resolve, reject) => {
    if (!scriptSrc) reject()

    const element = id ? document.querySelector(`#${id}`) : null

    if (element) resolve()

    const script = document.createElement('script')
    script.src = scriptSrc
    script.type = 'text/javascript'
    script.onload = resolve
    script.onerror = reject

    document.head.appendChild(script)
  })
}

export function appendStyle(source, id) {
  new Promise((resolve, reject) => {
    if (!source) reject()

    const element = id ? document.querySelector(`#${id}`) : null

    if (element) resolve()

    const link = document.createElement('link')
    link.id = id
    link.href = source
    link.rel = 'stylesheet'
    link.type = 'text/css';
    link.onload = resolve
    link.onerror = reject

    document.head.appendChild(link)
  })

}

export function saveUrlParam(param, value) {
  const searchParams = new URLSearchParams(location.search);
  searchParams.set(param, value)
  window.history.replaceState(null, null, `?${searchParams.toString()}`)
}

export function getUrlParams(...params) {
  const searchParams = new URLSearchParams(location.search);
  const urlParams = {}

  params.forEach(param => {
    urlParams[param] = searchParams.get(param)
  })

  return urlParams
}

export function isObjectEmpty(obj) {
  return obj && Object.keys(obj).length && obj.constructor === Object
    ? false
    : true
}

export function randomString(length) {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
  const charactersLength = characters.length;
  let result = '';

  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }

  result = 'A' + result

  return result;
}
